import { MouseEvent as ReactMouseEvent } from 'react';
import moment from 'moment';

import { BlockNavigationDropdownItem } from './BlockNavigationDropdown';

/** One dashboard pack in the nav dropdown, with optional page rows when loaded. */
export interface DashboardNavPack {
  id: string;
  title: string;
  description?: string;
  page_count?: number;
  updated_at?: string;
  pages: BlockNavigationDropdownItem[];
  source: Record<string, unknown>;
}

export const AVATAR_TINTS = [
  { bg: '#F1ECFE', fg: '#7C4EE0' },
  { bg: '#E7F0FF', fg: '#3B74E8' },
  { bg: '#E3F6F0', fg: '#0E9E7E' },
  { bg: '#FFF2E0', fg: '#D9850B' },
  { bg: '#FDEBF1', fg: '#D14D86' },
  { bg: '#ECEEFF', fg: '#5B5FE0' },
] as const;

export const hashIndex = (value: string, modulo: number): number => {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + (value.codePointAt(index) ?? 0)) % 100_000;
  }
  return hash % modulo;
};

export const initialsOf = (title: string): string =>
  title
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w.charAt(0))
    .join('')
    .toUpperCase() || '•';

export const compactAgo = (value?: string): string | null => {
  if (!value) return null;
  const then = moment.utc(value);
  if (!then.isValid()) return null;
  const now = moment.utc();
  const mins = now.diff(then, 'minutes');
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = now.diff(then, 'hours');
  if (hours < 24) return `${hours}h ago`;
  const days = now.diff(then, 'days');
  if (days < 7) return `${days}d ago`;
  return `${now.diff(then, 'weeks')}w ago`;
};

export const isModifiedClick = (event: ReactMouseEvent) =>
  event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
